import { lazy } from "react";

export const DashboardPage = lazy(() => import("../../Features/dashboard"));

export const AapleSarkarDashboardCount = lazy(
  () => import("../../Features/dashboard/components/DashboardCount")
);
